(() => {
  const initializeTermsGate = () => {
    const checkbox = document.getElementById('form-must-accept-terms');

    if (!checkbox) return;

    checkbox.addEventListener('change', () => {
      if (!checkbox.checked) return;

      document.querySelectorAll('.main-product__form-submit').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTermsGate, { once: true });
  } else {
    initializeTermsGate();
  }
})();
